module.exports = __webpack_public_path__ + "static/media/config.icon.0f44c0f2.svg";